import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import svg15 from "../../../assets/svg/svg15.svg";
import svg29 from "../../../assets/svg/svg29.svg";
import svg46 from "../../../assets/svg/svg46.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchCounties, fetchData } from "../../../features/fetch/fetchSlice";
import { cashConverter, extractYear, formatText } from "../../../utils";
import { setActiveObj } from "../../../features/obj/objSlice";
import DamView from "./DamView";
import ConfirmModal from "../../../components/ConfirmModal";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import moment from "moment";

function DamsTable({ pathwayId }) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "dam/fetch_dams";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { saving } = useSelector((state) => state.save);
  const { counties } = useSelector((state) => state.fetch);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [countyId, setCountyId] = useState(null);
  const [yearData, setYearData] = useState(null);

  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "dam/delete_dam",
        damId: prodd?.damId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        damName: e.target.value == "" ? null : e.target.value,
        county: countyId,
        damPathwayId: pathwayId ?? null,
        year: extractYear(yearData),
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "dam", data: prodd }));
    await navigate("/rob/dams-add");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "dam", data: {} }));
    await navigate("/rob/dams-add");
  };
  const handleView = async () => {
    await showDrawer();
  };
  const handleViewName = async (item) => {
    await setProdd(item);
    await showDrawer();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg46} alt="svg46" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg15} alt="svg15" /> View
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Dam Name",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.damName}
          </div>
        );
      },
      sorter: (a, b) => a.damName.localeCompare(b.damName),
    },

    {
      title: "Type",
      dataIndex: "dmType",
      sorter: (a, b) => a.dmType.localeCompare(b.dmType),
    },
    {
      title: "County",
      dataIndex: "countyCode",
      sorter: (a, b) => a.countyCode.localeCompare(b.countyCode),
    },
    {
      title: "Budget",
      dataIndex: "damCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.damCost.localeCompare(b.damCost),
    },
    {
      title: "Funding Source",
      dataIndex: "damSourceFunds",
      sorter: (a, b) => a.damSourceFunds.localeCompare(b.damSourceFunds),
    },
    {
      title: "Start Date",
      dataIndex: "damStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.damStartDate).valueOf() - moment(b.damStartDate).valueOf(),
    },
    {
      title: "Status",
      dataIndex: "damStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          SILTED: "#3250FF",
          DECOMMISSIONED: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    }, 
    {
      title: "Actions",
      render: (item) => (
        <>
          {pathwayId ? (
            <button onClick={() => handleViewName(item)}>
              <img src={svg15} alt="svg15" />
            </button>
          ) : (
            <Dropdown
              overlayStyle={{
                width: "250px",
              }}
              trigger={"click"}
              menu={{ items: settingItems }}
              placement="bottom"
            >
              <button onClick={() => setProdd(item)}>
                <img src={svg27} alt="svg27" />
              </button>
            </Dropdown>
          )}
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        county: countyId,
        year: extractYear(yearData),
        damPathwayId: pathwayId ?? null,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    dispatch(fetchCounties());
  }, []);

  useEffect(() => {
    fetchTableData();
  }, [yearData, countyId]);

  const onFinish = () => {};

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      {!pathwayId && <BreadCrumb breadcrumbs={[{ title: "Dams" }]} />}
      <div
        className={`flex flex-col w-full  flex-1   ${
          pathwayId ? "lg:px-0" : " lg:px-[1.25rem]  white_card mt-[1.25rem]"
        }`}
      >
        {!pathwayId ? (
          <>
            {" "}
            <div className="flex lg:flex-row flex-col  lg:items-center justify-between gap-y-4">
              <div className="form-add-h">Available Dams</div>
              <div className="w-[150px]">
                <button onClick={() => handleAdd()} className="cstm-btn-2">
                  <img src={svg29} alt="svg29" />{" "}
                  <span className="ml-1">Capture New</span>
                </button>
              </div>
            </div>
            <div className="flex items-center mt-[2.03rem] w-full gap-x-[1.25rem]">
              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                className="w-full  "
                form={form}
              >
                <div className="w-full flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
                  <span className="">Select County</span>
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      counties?.length > 0 &&
                      counties?.map((item) => ({
                        value: item?.countyName,
                        label: item?.countyName,
                      }))
                    }
                    value={countyId}
                    onChange={(value) => setCountyId(value)}
                    placeholder="Select"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                  />
                  <DatePicker
                    placeholder="Year"
                    className="input !w-[31.1rem]"
                    picker="year"
                    value={yearData}
                    onChange={(value) => setYearData(value)}
                  />
                </div>
              </Form>

              <div className="lg:w-[29.1875rem] w-auto ">
                <Search
                  searchInput={searchInput}
                  handleSearch={handleSearch}
                  text={"Search dam..."}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
        )}

        <Table
          rowSelection={false}
          className="mt-[1.31rem] w-full"
          scroll={{
            x: 1200,
          }}
          rowKey={(record) => record?.damId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>
      <DamView onClose={onClose} open={openDrawer} prodd={prodd} />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default DamsTable;
